import { Form, Formik } from 'formik';
import { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import FormFooter from '../../../components/form-footer';
import IntakeSubpoenaProcessServingDetailsFields from '../../../components/intake/subpoena-process-serving/details-fields';
import SubpoenaProcessServingDetailsSchema from '../../../validation-schemas/subpoena-process-serving-details-schema';
import { updateActiveFormSubpoenaProcessServingDetails, selectActiveFormSubpoenaProcessServingDetails } from '../../../reducers/active-form-slice';
import { resetSubpoenaDetailsFilesStatus, selectAllSubpoenaDetailsFiles, uploadSubpoenaDetailsFiles, deleteSubpoenaDetailsFiles } from '../../../reducers/subpoena-details-files-slice';
import FormHeaderButtons from '../form-header-buttons';
import { hasNonBlankValues } from '../../../utility/has-values';


const IntakeSubpoenaProcessServingDetails = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();


    /**
     * get current form values
     */
    const subpoenaProcessServingDetails = useSelector(selectActiveFormSubpoenaProcessServingDetails);
    const hasValues = hasNonBlankValues(subpoenaProcessServingDetails);


    /**
     * handle the previous button
     */
    const handlePrevious = () => {
        navigate("/intake/");
    };

      /**
     * handle the file upload & store returned info in state
     */
      const subpoenaDetailsFiles = useSelector(selectAllSubpoenaDetailsFiles);
      const subpoenaDetailsFilesStatus = useSelector(state => state.subpoenaDetailsFiles.status);
      const formRef = useRef();
  
      const handleUpload = (files) => {
          dispatch(uploadSubpoenaDetailsFiles(files));
      };
  
      const handleUploadedRemoval = (guid) => {
          dispatch(deleteSubpoenaDetailsFiles(guid));
      };
  
      useEffect(() => {
          if (subpoenaDetailsFilesStatus === "succeeded") {
              formRef.current.setFieldValue('files', subpoenaDetailsFiles.subpoenaDetailsFiles);
              dispatch(resetSubpoenaDetailsFilesStatus());
          }
      }, [subpoenaDetailsFiles, subpoenaDetailsFilesStatus, dispatch]);  


    /**
     * update active form & continue
     */
    const handleSubmit = (values) => {
        dispatch(updateActiveFormSubpoenaProcessServingDetails(values));
        navigate("/intake/additional-information");
    };

    /**
     * handle save for later
     */
    const handleSaveForLater = (values) => {
        dispatch(updateActiveFormSubpoenaProcessServingDetails(values));
    };


    /**
     * setup the initial values
     */
    const initialValues = {
        firstName: '',
        lastName: '',
        email: '',
        phone: '',
        address1: '',
        address2: '',
        city: '',
        stateProvince: '',
        zip: '',
        country: '',
        typeOfService: '',
        lastDayToComplete: '',
        vin: '',
        licensePlate: '',

        caseNumber: '',
        serveeFirstName: '',
        serveeLastName: '',
        files: [],
        doYouWantProofOfService: '',
        serviceAttempted: ''
    };


    return (
        <div className="page intake">
            <Formik
                initialValues={hasValues ? subpoenaProcessServingDetails : initialValues}
                validationSchema={SubpoenaProcessServingDetailsSchema.fields.subpoenaProcessServingDetails}
                onSubmit={handleSubmit}
            >
                {({ errors, dirty, isValid, touched, values }) => (
                    <Form>
                        <div className="form-header-buttons">
                            <div>
                                <h2>Subpoena Details</h2>
                                <p>FILL WITH “N/A” IF NOT APPLICABLE ON REQUIRED FIELDS</p>
                            </div>
                            <FormHeaderButtons updateForm={() => handleSaveForLater(values)}/>
                        </div>
                
                        <IntakeSubpoenaProcessServingDetailsFields
                            errors={errors}
                            touched={touched}
                            values={values}
                            handleUpload={handleUpload}
                            handleUploadedRemoval={handleUploadedRemoval}
                            uploadedFiles={subpoenaDetailsFiles.subpoenaDetailsFiles}
                            uploadStatus={subpoenaDetailsFilesStatus}
                        />

                        <FormFooter
                            handlePrevious={handlePrevious}
                            showPrevious={true}
                            disableNext={!((dirty || hasValues) && isValid)}
                            showNext={true}
                            progress={`50`}
                        />
                    </Form>
                )}
            </Formik>
        </div>
    );
};

export default IntakeSubpoenaProcessServingDetails;